import {HelpMediaProps} from "../../types/props";

import React from 'react';

const HelpMedia: React.FC<HelpMediaProps> = React.memo(({
  src,
  alt,
  poster,
  type = 'video',
  autoplay = false,
  loop = true
}) => {
  return (
    <div className="border rounded p-2 bg-light text-center">
      {type === 'video' ? (
        <video
          className="w-100"
          controls
          poster={poster}
          autoPlay={autoplay}
          loop={loop}
          muted={true}
          playsInline
          preload="auto"
        >
          <source src={src} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <img
          className="w-100"
          src={src}
          alt={alt}
        />
      )}
      <p className="text-muted small text-center mt-2 mb-0">{alt}</p>
    </div>
  );
});

export default HelpMedia;